import { render, staticRenderFns } from "./el_main.vue?vue&type=template&id=2d8e18a8&"
import script from "./el_main.vue?vue&type=script&lang=js&"
export * from "./el_main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports